$shm_hitalama_map_widget_float_notebook2 $shm_hitalama_map_widget_float_layout_vert
	Adds $shm_hitalama_map_widget_float_notebook2_adds
		Map_page <= Map_page
		add_types <= add_types /
			\text_md
			\code_js
			\iframe
